import React from "react";
import { Link } from "react-router-dom";
import { Badge } from "../../ui";

export const CaseTable = ({ items, id, loading = false }) => (
  <div className="cjms-case-table-wrap"><table className="cjms-table cjms-case-table" data-testid={id}>
    <thead><tr><th>Case number</th><th>Case name</th><th>Type</th><th>Status</th></tr></thead>
    <tbody>{loading ? <tr><td colSpan={4} data-testid={`${id}-loading`}>Loading cases…</td></tr> : !items?.length ? <tr><td colSpan={4} className="cjms-empty" data-testid={`${id}-empty`}>No cases to display.</td></tr> : items.map((c) => <tr key={c.id} data-testid={`${id}-row-${c.id}`}>
      <td><Link to={`/cases/${c.id}`} className="cjms-case-link" data-testid={`${id}-open-${c.id}`}>{c.case_number}</Link></td>
      <td><Link to={`/cases/${c.id}`} title={c.caption} className="cjms-case-caption" data-testid={`${id}-caption-${c.id}`}>{c.caption}</Link></td>
      <td data-testid={`${id}-type-${c.id}`}>{c.case_type?.replaceAll("_", " ")}</td><td><Badge value={c.status} testId={`${id}-status-${c.id}`} /></td>
    </tr>)}</tbody>
  </table></div>
);